<template>
	<div class="row my-4 filter-row">
		<div class="col-sm-2">
			<BaseInput
				name="Package Name"
				label="Package Name"
				type="text"
				v-model="filter.name"
				class="form-control form-control-lg dashInput"
			/>
		</div>
		<div class="form-group col-sm-2 mb-4">
			<BaseMultiSelect
				@update:value="setTags"
				:options="multiSelectState.tagsSelect"
				name="Tags"
			/>
		</div>
		<div class="form-group col-sm-2 mb-4">
			<BaseMultiSelect
				@update:value="setLimit"
				:options="multiSelectState.limitSelect"
				:defaultData="multiSelectState.limit"
				name="Result Limit"
			/>
		</div>
		<div class="form-group col-sm-2 mt-2 d-flex align-items-center">
			<BaseButton
				class="btn form-control btn-primary"
				type="submit"
				label="Search"
				@on:Click="setFilterQuery"
				:loading="false"
			/>
		</div>
	</div>
	<div class="row px-4 table-wrapper">
		<table-lite
			:is-loading="table.isLoading"
			:columns="table.columns"
			:rows="table.rows"
			:total="table.totalRecordCount"
			:sortable="table.sortable"
			:messages="table.messages"
			@do-search="doSearch"
			@is-finished="tableLoadingFinish"
			:pageOptions="[ { value: 10, text: 10 }, { value: 25, text: 25 }, { value: 50, text: 50 }, { value: 100, text: 100 }, { value: 500, text: 500 }, { value: 1000, text: 1000 } ]"
		/>
	</div>
</template>
<script>
	import { inject, reactive } from "vue";
	import { useRouter } from "vue-router";
	import toast from "@/config/toast";
	import API from "@/config/api";
    import TableLite from "vue3-table-lite";

	import BaseButton from "./BaseButton.vue";
	import BaseInput from "./BaseInput.vue";
	import BaseMultiSelect from "./BaseMultiSelect.vue";

	export default {
		name: "PackagesTable",
		components: {
			TableLite,
			BaseButton,
			BaseInput,
			BaseMultiSelect
		},
		setup: () => {
			const store = inject("store");
			const masterStore = inject("masterStore");
			const router = useRouter();

			const state = reactive({
				fetchedData: false,
				message: "Loading Data...",
			});

			if (!store.state.auth.isAuth) router.push({ name: "Login" });

			const table = reactive({
				isLoading: false,
				columns: [
					{
						label: "Name",
						field: "name",
						width: "8%",
						sortable: true,
						display: function (row) {
							return `<b>${row.name}</b>`;
						},
					},
					{
						label: "Country",
						field: "",
						width: "8%",
						sortable: false,
						display: function (row) {
							return `<div>${row.country.name}</div>`;
						},
					},
					{
						label: "City / Stay",
						field: "",
						width: "8%",
						sortable: false,
						display: function (row) {
							let cityStay = "";
							row.cities.map((city) => {
								cityStay = `${cityStay} <span class="is-rows-el quick">${city.city.name} / ${city.stayNights}</span><br>`;
							});
							return `<div>${cityStay}</div>`;
						},
					},
					{
						label: "Tags",
						field: "",
						width: "8%",
						sortable: false,
						display: function (row) {
							let tag = "";
							row.tags.map(
								(tagObj) =>
									(tag = `${tag}<span class="is-rows-el quick"> ${tagObj.name}</span><br>`),
							);
							return `<div>${tag}</div>`;
						},
					},
					{
						label: "Overview",
						field: "overview",
						width: "8%",
						sortable: false,
					},
					{
						label: "Meal",
						field: "meal",
						width: "8%",
						sortable: false,
					},
					{
						label: "Temporary Package",
						field: "isTemp",
						width: "6%",
						sortable: false,
						display: function (row) {
							return `${row?.isTemp ? 'Yes':'No'}`
						}
					},
					{
						label: "Actions",
						field: "",
						width: "2%",
						sortable: false,
						display: function (row) {
							return `<div class="d-flex justify-content-around align-items-center">
									<button type="button" data-id="${row._id}"
									data-action="show"
									class="is-rows-el action-btn btn btn-success"><i class="bi bi-eye"></i></button>
	                               <button type="button" data-id="${row._id}"
	                                data-action="edit"
	                               class="is-rows-el action-btn btn btn-warning">
	                               <i class="bi bi-pencil-square"></i>
	                               </button>
	                               <button type="button" data-id="${row._id}"
	                                data-action="delete"
	                               class="is-rows-el action-btn btn btn-danger"><i class="bi bi-trash"></i></button>
	                               </div>`;
						},
					},
				],
				rows: [],
				totalRecordCount: 10,
				sortable: {
					sort: "desc",
				},
			});

			const filter = reactive({
				enabled: false,
				name: null,
				tags: [],
			});

			const multiSelectState = reactive({
				tags: [],
				tagsSelect: [],
				filterQuery: "",
				limit: 10,
				limitSelect: [5, 10, 15, 20, 25, 30, 35, 40, 50, 60, 80, 100, 150, 200],
			});

			const getPackages = async () => {
				try {
					const { data } = await API.privateRequest.get("packages?sort=desc");
					if (!data.data.length) {
						state.message = "Data not available";
						return;
					}
					masterStore.methods.changeData(data.data);
					table.rows = data.data;
					table.totalRecordCount = data.count;
					table.isLoading = false;
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
					state.message = "Please Try Again !";
				}
			};

			const doSearch = async (offset, limit, order, sort) => {
				try {
					table.isLoading = true;
					let url = "";

					if (multiSelectState.filterQuery) {
						url = `${url}${multiSelectState.filterQuery}`;
					}
					if (offset) url = `${url}offset=${offset}&`;
					if (limit) url = `${url}limit=${limit}&`;
					if (order) url = `${url}order=${order}&`;
					if (sort) url = `${url}sort=${sort}`;

					const response = await API.privateRequest.get(`packages?${url}`);

					table.rows = response?.data.data;
					table.totalRecordCount = response?.data?.count;
					table.sortable.order = order;
					table.sortable.sort = sort;
					table.isLoading = false;
				} catch (err) {
					alert(err);
				}
			};

			const tableLoadingFinish = (elements) => {
				// console.log(document.querySelector(".quick-btn"));
				table.isLoading = false;

				Array.prototype.forEach.call(elements, function (element) {
					// if (element.classList.contains("name-btn")) {
					// 	element.addEventListener("click", function () {
					// 		console.log(this.dataset.id + " name-btn click!!");
					// 	});
					// }
					if (element.classList.contains("quick-btn")) {
						element.addEventListener("click", function () {
							changeStatus(this.dataset.id, this.dataset.status);
						});
					}
					if (element.classList.contains("action-btn")) {
						element.addEventListener("click", function () {
							changeComponent(this.dataset.id, this.dataset.action);
						});
					}
				});
			};

			const changeComponent = (id, action) => {
				id = id.trim();
				action = action.trim();
				try {
					if (action === "delete") {
						masterStore.methods.setId("delete", id);
						table.rows = table.rows.filter((row) => row._id !== id);
					} else if (action === "show") {
						masterStore.methods.changeComponent("view");
						masterStore.methods.changeData(
							table.rows.filter((row) => row._id === id)[0],
						);
					} else if (action === "edit") {
						masterStore.methods.setId("edit", id);
						masterStore.methods.changeData(
							table.rows.filter((row) => row._id === id)[0],
						);
						masterStore.methods.changeComponent("edit");
					}
				} catch (err) {
					console.log("error in UserTable actions");
				}
			};

			const getTags = async () => {
				try {
					const response = await API.privateRequest.get("tags");
					const changedTags = response.data.data.map((tag) => ({
						value: tag._id,
						label: tag.name,
					}));
					multiSelectState.tags = response.data.data;
					multiSelectState.tagsSelect = changedTags;
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
				}
			};

			const setFilterQuery = () => {
				let queryString = "";
				let keys = Object.keys(filter);
				keys = keys.filter((key) => key !== "enabled");
				keys = keys.filter((key) => {
					
					if (filter[key] instanceof Array && !filter[key].length) {
						return null
					} else if (filter[key]) return key 
					else return null
			
				});
				keys.map((key, index) =>
					index === 0
						? (queryString = `${key}=${filter[key]}&`)
						: (queryString = `${queryString}&${key}=${filter[key]}&`),
				);

				if (!filter.tags.length) {
					queryString = queryString.replace("tags=", "");
				}

				multiSelectState.filterQuery = queryString;
				doSearch(false, multiSelectState.limit, "desc");
			};

			const setLimit = (limit) => {
				multiSelectState.limit = limit;
			};
			const setTags = (dataObj) => {
				
				filter.tags = dataObj;
			
				
			};

			getPackages();
			getTags();

			return {
				masterStore,
				state,
				table,
				filter,
				multiSelectState,

				doSearch,
				tableLoadingFinish,
				setFilterQuery,
				setLimit,
				setTags
			};
		},
	};
</script>
<style scoped>
	::v-deep(.vtl-paging-info) {
		font-size: 0.8rem;
	}
	::v-deep(.vtl-paging-count-label),
	::v-deep(.vtl-paging-page-label) {
		padding-left: 1rem;
		padding-right: 0.4rem;
		font-size: 0.8rem;
	}
	::v-deep(.vtl-paging-pagination-div) {
		padding-bottom: 1rem;
		font-size: 0.8rem;
	}
	::v-deep(.vtl-tbody),
	::v-deep(.vtl-thead-th) {
		font-size: 0.8rem;
	}

	::v-deep(.vtl-tbody-td > div) {
		height: 100%;
	}

	::v-deep(.vtl-tbody-tr .vtl-tbody-td) {
		border: none;
	}
	::v-deep(.vtl-thead-tr) {
		border-bottom: 1px groove rgba(168, 167, 167, 0.442);
	}
	::v-deep(.vtl-thead-tr .vtl-thead-th) {
		background: rgb(255, 255, 255);
		color: #000;
		border: none;
	}
	::v-deep(.vtl-card) {
		padding: 0;
		border-radius: 20px;
		overflow: hidden;
	}
	::v-deep(.vtl-paging) {
		padding: 0 1rem;
	}
	.vtl-thead-td::nth-child(5) {
		background: red;
	}
</style>
